import countries from "venuescanner-js/constants/countries.json";
const defaultCode = "GB";
const country = (code = defaultCode) => {
  return countries[code];
};
export default country;
